module.exports = __webpack_public_path__ + "static/media/4.5359bd57.jpg";